<app-loader></app-loader>
<div class="credentials-page">
  <!-- Top Banner -->
  <div class="game-banner" [style.background]="cardBackground">
    <!-- <div class="gd-hero-grad" style="background:linear-gradient(to top, #151533, #b4cfb7, #a0baa9);"></div> -->
    <div class="banner-content">
      <div class="banner-logo-card">
        <img [src]="getGameImage(gameName || '')" [alt]="gameName" />
      </div>
      <div class="banner-info">
        <span class="premium-badge">PREMIUM</span>
        <h1 class="banner-title">{{ gameName || 'Game' }}</h1>
        <p class="banner-description">
          {{selectedGameDetails?.description}}
        </p>
      </div>
      <button class="banner-play-btn" (click)="playGame(gameName || '')">
        <i class="fas fa-play"></i> PLAY NOW
      </button>
    </div>
  </div>

  <!-- Main Grid -->
  <ng-container *ngIf="hasGameAccount; else createAccountPanel">
    <div class="main-grid">
      <!-- Left: Game Account -->
      <div class="account-card">
        <div class="card-label">GAME ACCOUNT</div>

        <div class="account-row">
          <div class="row-icon"><fa-icon [icon]="User"></fa-icon></div>
          <div class="row-body">
            <span class="row-label">User Name</span>
            <span class="row-value">{{ playerName || '-' }}</span>
          </div>
          <fa-icon [icon]="copy" class="copy-icon" (click)="CopyToClipBoard(playerName)"></fa-icon>
        </div>

        <div class="account-row">
          <div class="row-icon"><fa-icon [icon]="Lock"></fa-icon></div>
          <div class="row-body">
            <span class="row-label">Password</span>
            <span class="row-value">{{ playerPassword || '-' }}</span>
          </div>
          <fa-icon [icon]="copy" class="copy-icon" (click)="CopyToClipBoard(playerPassword)"></fa-icon>
        </div>

        <div class="stats-row">
          <div class="stat-pill">
            <span class="stat-value">{{ scoreValue ? scoreValue.toLocaleString() : '0' }}</span>
            <span class="stat-label">SCORE</span>
          </div>
          <div class="stat-pill">
            <span class="stat-value">{{ offerOnGame || 0 }}%</span>
            <span class="stat-label">OFFER</span>
          </div>
        </div>

        <div class="account-actions">
          <button class="btn-gold" (click)="openAddScoreModal()">
            <i class="fas fa-plus"></i> ADD SCORE
          </button>
          <button class="btn-dark" (click)="openDeleteAccountModal()">
            <i class="fas fa-user-gear"></i> CHANGE ACCOUNT
          </button>
        </div>
      </div>

      <!-- Right: Actions & History -->
      <div class="actions-card">
        <div class="action-list">
          <div class="action-item" (click)="openAddScoreModal()">
            <div class="action-icon gold"><i class="fas fa-plus"></i></div>
            <div class="action-text">
              <span class="action-title">ADD SCORE</span>
              <span class="action-sub">Add credits to your game account</span>
            </div>
            <i class="fas fa-chevron-right action-arrow"></i>
          </div>
          <div class="action-item" (click)="RedirectToRedeem()">
            <div class="action-icon red"><i class="fas fa-minus"></i></div>
            <div class="action-text">
              <span class="action-title">REDEEM SCORE</span>
              <span class="action-sub">Withdraw credits from your game account</span>
            </div>
            <i class="fas fa-chevron-right action-arrow"></i>
          </div>
          <div class="action-item" (click)="scrollToHistory()">
            <div class="action-icon blue"><i class="fas fa-history"></i></div>
            <div class="action-text">
              <span class="action-title">GAME HISTORY</span>
              <span class="action-sub">View your recent transactions</span>
            </div>
            <i class="fas fa-chevron-right action-arrow"></i>
          </div>
        </div>

        <button class="play-bar" (click)="playGame(gameName || '')">
          <i class="fas fa-play"></i> PLAY NOW
        </button>

        <!-- History -->
        <div class="history-section" id="gameHistorySection">
          <div class="history-tabs">
            <button *ngFor="let tab of historyTabs" [class.active]="historyFilter === tab.value"
              (click)="historyFilter = tab.value">
              {{ tab.label }}
            </button>
          </div>

          <div class="history-table-wrap">
            <div class="history-table-header">
              <span>DATE</span>
              <span>TYPE</span>
              <span>SCORE</span>
              <span>AMOUNT</span>
              <span>WALLET</span>
            </div>
            <div class="history-table-body">
              <div *ngIf="filteredScoreHistory.length === 0" class="no-history">
                No transactions this period.
              </div>
              <div *ngFor="let entry of filteredScoreHistory" class="history-row">
                <span>{{ entry.AddedDate | localTime }}</span>
                <span class="type-cell" [class.score]="entry.ActionType === 'Score'"
                  [class.redeem]="entry.ActionType === 'Redeem'">
                  {{ entry.ActionType }}
                </span>
                <span>{{ entry.TotalScore }}</span>
                <span>{{ entry.Score }}</span>
                <span>-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #createAccountPanel>
    <div class="create-account-panel">
      <div class="create-account-card">
        <h3 class="panel-title">WHAT YOU GET</h3>
        <ul class="benefit-list">
          <li>
            <div class="benefit-icon"><i class="fas fa-coins"></i></div>
            <div class="benefit-text">
              <strong>Add score, redeem winnings</strong>
              <span>Top up your score and cash out directly to your wallet</span>
            </div>
          </li>
          <li>
            <div class="benefit-icon"><i class="fas fa-clock-rotate-left"></i></div>
            <div class="benefit-text">
              <strong>Track your game history</strong>
              <span>Full transaction log for every score add and redemption</span>
            </div>
          </li>
          <li>
            <div class="benefit-icon"><i class="fas fa-bolt"></i></div>
            <div class="benefit-text">
              <strong>One-tap play on any device</strong>
              <span>Browser, Android or iOS — your credentials saved</span>
            </div>
          </li>
        </ul>
        <div class="px-5 py-4 border-t border-slate-800/40">
          <button class="btn-create-account" (click)="createGameAccount()">
            <i class="fas fa-plus"></i> CREATE ACCOUNT
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- More Games -->
  <div class="more-games-section">
    <h2 class="section-title">MORE GAMES</h2>
    <!-- <div class="more-games-carousel"> -->
    <!-- <button class="carousel-arrow left" (click)="scrollMoreGames(-1)">
        <i class="fas fa-chevron-left"></i>
      </button> -->
    <div class="more-games-track gd-rail flex gap-3 overflow-x-auto pb-2 -mx-1 px-1" id="moreGamesTrack">
      <app-game-card *ngFor="let g of moreGames" [game]="g" [statusLabel]="getStatus(g).label"
        [statusActive]="getStatus(g).active" (cardClick)="playMoreGame(g)"></app-game-card>
    </div>
    <!-- <button class="carousel-arrow right" (click)="scrollMoreGames(1)">
        <i class="fas fa-chevron-right"></i>
      </button> -->
    <!-- </div> -->
  </div>

  <!-- Add Score Modal -->
  <div *ngIf="showAddScoreModal" class="modal-overlay" (click)="closeAddScoreModal()">
    <div class="modal modal-card slide-up" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>
          <h2>ADD SCORE</h2>
          <p class="modal-subtitle">{{ gameName || 'Game' }} · $1/pt</p>
        </div>
        <button (click)="closeAddScoreModal()">
          <fa-icon [icon]="cross"></fa-icon>
        </button>
      </div>

      <!-- <div class="wallet-toggle">
        <button type="button" [class.active]="selectedWallet === 'main'" (click)="selectedWallet = 'main'">
          MAIN WALLET
        </button>
        <button type="button" [class.active]="selectedWallet === 'bonus'" (click)="selectedWallet = 'bonus'">
          BONUS WALLET
        </button>
      </div> -->

      <div class="current-score-row">
        <span>Current Score</span>
        <span class="score-value">
          @if (isScoreLoading) {
          <span class="loading-dots">
            <span></span><span></span><span></span>
          </span>
          } @else {
          @if (currentScore === '' || currentScore === null || currentScore === undefined || currentScore === 'allow') {
          <fa-icon (click)="getScoreforAddding()" [icon]="refresh" class="refresh-icon"></fa-icon>
          } @else {
          <strong>{{ currentScore }}</strong>
          }
          }
          <fa-icon (click)="getScoreforAddding()" [icon]="refresh" class="refresh-icon"></fa-icon>
        </span>
      </div>

      <form [formGroup]="scoreForm" (ngSubmit)="IsScoreValid()" class="modal-form">
        <div class="form-row two-col">
          <div class="form-group">
            <label>SCORE AMOUNT</label>
            <input type="number" formControlName="score" [placeholder]="getPlaceholder()" />
            <div class="error-text">
              <ng-container
                *ngIf="scoreForm.get('score')?.hasError('required') && scoreForm.get('score')?.touched">Score is
                required.</ng-container>
              <ng-container *ngIf="scoreForm.get('score')?.hasError('min') && scoreForm.get('score')?.touched">Score
                must be at least 1.</ng-container>
              <ng-container
                *ngIf="scoreForm.get('score')?.hasError('notInteger') && scoreForm.get('score')?.touched">Score must be
                an integer.</ng-container>
            </div>
          </div>
          <div class="form-group total-cost">
            <label>TOTAL COST</label>
            <div class="cost-box">
              <i class="fas fa-dollar-sign"></i>
              <span>{{ scoreForm.get('score')?.value || '0' }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>PROMO CODE (optional)</label>
          <input type="text" name="promoCode" [(ngModel)]="promoCode" placeholder="Enter promo code" />
        </div>

        <button type="submit" [disabled]="scoreForm.invalid" class="btn-gold-modal">
          ADD SCORE <i class="fas fa-arrow-right"></i>
        </button>
      </form>
    </div>
  </div>

  <!-- Confirm Payment Modal -->
  <div *ngIf="showPaymentModal" class="modal-overlay" (click)="closePaymentModal()">
    <div class="modal modal-card slide-up" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>
          <h2>ADD SCORE</h2>
          <p class="modal-subtitle">Confirm your purchase</p>
        </div>
        <button (click)="closePaymentModal()">
          <fa-icon [icon]="cross"></fa-icon>
        </button>
      </div>

      <form [formGroup]="paymentForm" (ngSubmit)="onPaymentSubmit()" class="modal-form">
        <div *ngIf="requestId" class="retry-banner">
          <div class="flex-1 min-w-0">
            <p class="text-xs leading-relaxed">
              <span class="font-mono font-semibold break-all">Retry For {{ requestId }}</span>
              <span class="mx-2">•</span>
              If you're unable to add score after 2-3 retry attempts, please contact our support team and provide this
              Request ID.
            </p>
          </div>
          <button type="button" (click)="CopyToClipBoard(requestId)" title="Copy Request ID">
            <fa-icon [icon]="copy"></fa-icon>
          </button>
        </div>

        <div class="form-row two-col">
          <div class="form-group">
            <label>PURCHASE</label>
            <input type="text" formControlName="purchase" [(ngModel)]="addedScore" readonly />
          </div>
          <div class="form-group">
            <label>SCORE</label>
            <input type="text" formControlName="confirmScore" [(ngModel)]="roundedUpdatedGivenScore" readonly />
          </div>
        </div>

        <p class="offer-text" *ngIf="offerOnGame > 0">
          With the current offer, your score will be increased by {{ offerOnGame }}% for a purchase of ${{ addedScore
          }}, resulting in a total score of {{ updatedGivenScore }}.
        </p>

        <button type="submit" class="btn-gold-modal">
          CONFIRM <i class="fas fa-arrow-right"></i>
        </button>
      </form>
    </div>
  </div>

  <!-- Captcha Modal -->
  <div *ngIf="showCaptchaModal"
    class="fixed inset-0 bg-black/80 flex items-center justify-center opacity-95 modal-overlay"
    (click)="closeCaptchaModal()">
    <div class="bg-[#2A2A2A] rounded-xl p-6 w-96 modal slide-up" (click)="$event.stopPropagation()">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-bold">CAPTCHA Security Check</h2>
        <button (click)="closeCaptchaModal()" class="text-gray-400 hover:text-white">X</button>
      </div>
      <form [formGroup]="captchaForm" (ngSubmit)="onCaptchaSubmit()">
        <div class="mb-4">
          <img [src]="captchaImage" alt="CAPTCHA" class="w-full mb-4 rounded-lg" />
          <input type="text" formControlName="captcha" placeholder="Write the text you see on the image"
            class="w-full bg-[#2a2438] border border-gray-700 rounded-lg px-4 py-2 text-white" />
        </div>
        <button type="submit" class="w-full back hover:bg-purple-700 py-2 rounded-lg">Submit</button>
      </form>
    </div>
  </div>

  <!-- Change Account Modal -->
  <div *ngIf="showDeleteAccountModal" class="modal-overlay" (click)="closeDeleteAccountModal()">
    <div class="modal modal-card slide-up" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>
          <h2>CHANGE ACCOUNT</h2>
          <p class="modal-subtitle">This will reset your current progress</p>
        </div>
        <button (click)="closeDeleteAccountModal()">
          <fa-icon [icon]="cross"></fa-icon>
        </button>
      </div>
      <div class="modal-body text-center">
        <div class="warning-icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <p class="modal-body-title">Change Game Account?</p>
        <p class="modal-body-text">
          Changing your current game account will
          <span class="highlight">RESET YOUR CURRENT PROGRESS</span>. A new fresh account will be created for you
          immediately.
        </p>
      </div>
      <div class="modal-actions two-col">
        <button (click)="closeDeleteAccountModal()" class="btn-secondary">Cancel</button>
        <button (click)="confirmDeleteAccount()" class="btn-gold-modal">Yes, Change</button>
      </div>
    </div>
  </div>

  <!-- Final Confirmation Modal -->
  <div *ngIf="showDeleteConfirmModal" class="modal-overlay" (click)="closeDeleteConfirmModal()">
    <div class="modal modal-card slide-up" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>
          <h2>FINAL CONFIRMATION</h2>
          <p class="modal-subtitle">One last step</p>
        </div>
        <button (click)="closeDeleteConfirmModal()">
          <fa-icon [icon]="cross"></fa-icon>
        </button>
      </div>
      <div class="modal-body text-center">
        <div class="warning-icon pulse">
          <i class="fa-solid fa-circle-exclamation"></i>
        </div>
        <p class="modal-body-title">Confirm Account Change!</p>
        <p class="modal-body-text">
          Please confirm one last time. By clicking change, your current account progress will be
          <span class="highlight underline">RESET</span>. A new account with zero balance will be assigned to you.
        </p>
      </div>
      <div class="modal-actions stack">
        <button (click)="deleteAccount()" class="btn-gold-modal">
          I UNDERSTAND, CHANGE MY ACCOUNT
        </button>
        <button (click)="closeDeleteConfirmModal()" class="btn-text">
          Actually, keep my account
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showRedeemModal" (click)="closeRedeemModal()">
  <app-add-redeem [isFromRedeem]="false" [showModal]="showRedeemModal" (closeModal)="closeRedeemModal()"
    [selectedGame]="selectedGame" [requestId]="requestId" (isModalOpen)="showRedeemModal = $event"></app-add-redeem>
</div>

@if (isCopied()) {
<div
  class="fixed bottom-[15%] left-1/2 transform -translate-x-1/2 bg-[#2C2C2C] text-white px-5 py-3 rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.2)] transition-opacity duration-300 z-50 flex items-center gap-3 border border-[#3A3A3A]">
  <fa-icon [icon]="faCheck" class="text-[#4CAF50] text-lg"></fa-icon>
  <span class="text-sm font-medium">Copied to clipboard</span>
</div>
}